/**
 * Collection Page Scripts
 * Handles facet filtering, AJAX grid updates, pagination,
 * filter drawer toggle, and sticky toolbar detection.
 */

/* -------------------------------------------------------
   Filtering
   ------------------------------------------------------- */

/**
 * Apply selected filters from the facet form.
 * If the user switched to a different collection, hard-navigate;
 * otherwise AJAX-update the grid.
 */
function applyFilters(event) {
    event.preventDefault();
    const form = document.getElementById('FacetFiltersForm');
    if (!form) return;

    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    const selectedCollection = formData.get('collection_handle');

    let baseUrl = window.location.origin + window.location.pathname;
    let isCollectionSwitch = false;

    if (selectedCollection) {
        searchParams.delete('collection_handle');
        const newPath = window.Shopify.routes.root + 'collections/' + selectedCollection;

        if (!window.location.pathname.includes(selectedCollection)) {
            baseUrl = newPath;
            isCollectionSwitch = true;
        }
    }

    const url = new URL(baseUrl);
    url.search = searchParams.toString();

    if (isCollectionSwitch) {
        window.location.href = url.toString();
        return;
    }

    fetchAndRender(url);
    toggleFilterPanel();
}

/**
 * Fetch the collection page at `url` and swap grid, filters, and count.
 */
function fetchAndRender(url) {
    const grid = document.querySelector('.collection-products');
    if (grid) grid.style.opacity = '0.5';

    fetch(url.toString())
        .then(res => res.text())
        .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            replaceElement('.collection-products', doc);
            replaceElement('#FacetFiltersForm', doc, true);
            replaceElement('.collection-count', doc, true);

            if (grid) grid.style.opacity = '1';
            history.pushState(null, '', url.toString());
        })
        .catch(() => {
            window.location.href = url.toString();
        });
}

/**
 * Replace an element's innerHTML with its counterpart from a parsed document.
 * @param {string} selector - CSS selector for the element.
 * @param {Document} doc - Parsed HTML document.
 * @param {boolean} [innerOnly=false] - Replace innerHTML only (true) or outer element.
 */
function replaceElement(selector, doc, innerOnly) {
    const newEl = doc.querySelector(selector);
    const curEl = document.querySelector(selector);
    if (!newEl || !curEl) return;
    curEl.innerHTML = newEl.innerHTML;
}

/* -------------------------------------------------------
   Filter drawer
   ------------------------------------------------------- */

function toggleFilterPanel() {
    const drawer = document.getElementById('FilterDrawer');
    const overlay = document.getElementById('FilterDrawerOverlay');
    if (!drawer || !overlay) return;

    drawer.classList.toggle('is-visible');
    overlay.classList.toggle('is-visible');
    document.body.style.overflow = drawer.classList.contains('is-visible') ? 'hidden' : '';
}

/* -------------------------------------------------------
   Pagination
   ------------------------------------------------------- */

function updatePaginationLimit(value) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { pagination: value } }),
    })
        .then(() => window.location.reload())
        .catch(() => {});
}

/* -------------------------------------------------------
   Browser back/forward
   ------------------------------------------------------- */

window.addEventListener('popstate', () => window.location.reload());

/* -------------------------------------------------------
   Sticky toolbar detection
   ------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', () => {
    const toolbar = document.querySelector('.collection-toolbar');
    if (!toolbar) return;

    const sentinel = document.createElement('div');
    sentinel.className = 'collection-toolbar-sentinel';
    sentinel.style.height = '1px';
    sentinel.style.marginBottom = '-1px';
    toolbar.parentNode.insertBefore(sentinel, toolbar);

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                toolbar.classList.toggle('is-stuck', !entry.isIntersecting);
            });
        },
        { threshold: 0 }
    );

    observer.observe(sentinel);
});
